<div class="main-blocks" nz-row>
  <div
    nz-col
    nz-col
    class="gutter-row"
    [nzXs]="0"
    [nzSm]="0"
    [nzMd]="0"
    [nzLg]="9"
    [nzXl]="9"
    [nzXXl]="9"
  >
    <!-- <div class="loginImg">
            <div class="imagAdj">
                <img src="../../../assets/img/login.png" alt="login">
            </div>
            <div class="infoprime">Learn more about Terragon Prime</div>
        </div> -->
    <app-sidepanel></app-sidepanel>
  </div>
  <div
    nz-col
    class="gutter-row"
    [nzXs]="24"
    [nzSm]="24"
    [nzMd]="24"
    [nzLg]="15"
    [nzXl]="15"
    [nzXXl]="15"
    class="block-right"
  >
    <div class="formblock">
      <div
        class="mainLogo gutter-row"
        nz-col
        [nzXs]="24"
        [nzSm]="24"
        [nzMd]="24"
        [nzLg]="0"
        [nzXl]="0"
        [nzXXl]="0"
      >
        <div class="logo">
          <img src="../../../assets/icons/terragonLogo.svg" />
        </div>
      </div>
      <h1 nz-typography>Reset password</h1>
      <div class="titleDesc">Create a new password to reset your account.</div>
      <form nz-form [formGroup]="validateForm" (ngSubmit)="submitForm()">
        <nz-form-item>
          <nz-form-label
            [nzSm]="24"
            [nzXs]="24"
            nzFor="password"
            class="inputLabel"
            nzRequired
            >New Password</nz-form-label
          >
          <nz-form-control
            [nzSm]="24"
            [nzXs]="24"
            nzErrorTip="Please enter your new password"
          >
            <input
              nz-input
              [type]="passwordVisible ? 'text' : 'password'"
              id="password"
              formControlName="password"
              class="w-100 padd-input"
              placeholder="Enter a password"
              (click)="triggerGAInput('new-password')"
            />
            <div
              class="password-toggle"
              (click)="togglePasswordVisibility()"
              [ngStyle]="{ opacity: passwordVisible ? '1' : '0.3' }"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="32"
                height="32"
                svg-inline=""
                role="presentation"
                focusable="false"
                tabindex="-1"
                class="toggled password-visibility"
              >
                <path
                  d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                ></path>
              </svg>
            </div>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label
            [nzSm]="24"
            [nzXs]="24"
            nzFor="password"
            class="inputLabel"
            nzRequired
            (click)="triggerGAInput('confirm-new-password')"
            >Confirm New Password</nz-form-label
          >
          <nz-form-control
            [nzSm]="24"
            [nzXs]="24"
            nzErrorTip="Please re-enter your new password"
          >
            <input
              nz-input
              [type]="passwordVisible2 ? 'text' : 'password'"
              id="repassword"
              formControlName="repassword"
              class="w-100 padd-input"
              placeholder="Confirm password"
            />
            <div
              class="password-toggle"
              (click)="togglePasswordVisibility2()"
              [ngStyle]="{ opacity: passwordVisible2 ? '1' : '0.3' }"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="32"
                height="32"
                svg-inline=""
                role="presentation"
                focusable="false"
                tabindex="-1"
                class="toggled password-visibility"
              >
                <path
                  d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                ></path>
              </svg>
            </div>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item nz-row class="register-area">
          <nz-form-control [nzSpan]="24">
            <button nz-button nzType="primary" class="w-100 padd-top" (click)="triggerGAButton('reset-password')">
              Reset Password
            </button>
          </nz-form-control>
        </nz-form-item>
      </form>
      <button
        nz-button
        nzType="text"
        class="extralink"
        (click)="triggerGAButton('back-to-login')"
      >
        Back to Login >
      </button>
    </div>
  </div>
  <div class="chatPosition triggerGA" dataEventLabel="reset-password-chatbot_click" dataEventCategory="auth-reset-password_page" dataEventAction="chatbot_click">
    <a
      href=""
      onclick="javascript:$zoho.salesiq.floatwindow.visible('show')"
      href="javascript:void(0)"
    >
      <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="28" cy="28" r="28" fill="#008138" />
        <path
          d="M33.8277 27.5518C33.8277 28.1067 33.6073 28.6388 33.215 29.0311C32.8227 29.4234 32.2906 29.6438 31.7358 29.6438H19.1839L15 33.8277V17.092C15 16.5371 15.2204 16.005 15.6127 15.6127C16.005 15.2204 16.5371 15 17.092 15H31.7358C32.2906 15 32.8227 15.2204 33.215 15.6127C33.6073 16.005 33.8277 16.5371 33.8277 17.092V27.5518Z"
          fill="white"
        />
        <path
          d="M22.1724 33.8284C22.1724 34.3832 22.3928 34.9153 22.7851 35.3077C23.1774 35.7 23.7095 35.9204 24.2643 35.9204H36.8162L41.0001 40.1043V23.3686C41.0001 22.8137 40.7797 22.2816 40.3874 21.8893C39.9951 21.497 39.463 21.2766 38.9081 21.2766H24.2643C23.7095 21.2766 23.1774 21.497 22.7851 21.8893C22.3928 22.2816 22.1724 22.8137 22.1724 23.3686V33.8284Z"
          fill="white"
          stroke="#008138"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </a>
  </div>
</div>
